import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { catchError, finalize, Observable, throwError } from 'rxjs';
import { LoaderHandlerService } from '../shared/common-services/overlay-loader-service/loader-handler.service';
import { AlertDialogComponent } from '../shared/components/alert-dialog/alert-dialog.component';
import { SharedService } from '../shared/common-services/shared.service';
import { environment } from 'src/environments/environment';
import { DataService } from '../shared/common-services/data.service';
import { ApiConstants } from './endpointsAndGeneric-constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class NetworkInterceptorService implements HttpInterceptor {
  isDialogActive: boolean = false;
  constructor(private router: Router, private loaderHandler: LoaderHandlerService, public dialog: MatDialog, private sharedService: SharedService, private _dataService: DataService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = request.clone({
      setHeaders: this.setHeader(request)
    });
    return next.handle(request).pipe(
      finalize(() => this.loaderHandler.toggleLoader(0)),
      catchError((error: HttpErrorResponse) => {
        let errorMsg = ''; let errorType = null;
        if (error && error.error) {
          if (error.status && error?.error && error?.error?.message) {
            errorMsg = `${error.error.message}`;
            errorType = error?.error?.errorType ? error?.error?.errorType : null;
          } else if (error?.status && error?.error?.response && error?.error?.response?.message) {
            errorMsg = `${error.error.response.message}`;
            errorType = error.error.response?.errorType ? error.error.response?.errorType : null;
          } else {
            errorMsg = `Error Code: ${error.status}, Message:${error.statusText}`;
            errorType = null;
          }
        } else {
          errorMsg = `Error Code: ${error.status}, Message:${error.statusText}`;
          errorType = null;
        }
        if (error.status === 401 && errorType !== 2) {
          this._dataService.broadcast('sessionTimeout');
          this.handleAuthError(errorMsg);
        }
        this.sharedService.toastrHandler({ type: 'error', msg: errorMsg });
        return throwError(() => errorMsg);
      }));
  }
  private handleAuthError(errorMsg: any) {
    localStorage.clear();
    sessionStorage.clear();
    if (!this.isDialogActive) {
      this.isDialogActive = true;
      let dialogRef = this.dialog.open(AlertDialogComponent, {
        data: { msg: 'Session Got Expired!', type: 'hideCancel' },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isDialogActive = false;
          this.loaderHandler.toggleLoader(0);
          this.router.navigate(['/user-authentication']);
          window.location.reload();
        }
      });
    }
  }

  private getToken() {
    let token = localStorage.getItem('token');
    if (token) {
      return token;
    } else {
      return this.router?.url?.includes('/login') ? `${ApiConstants.APP_TOKEN}` : null;
    }
  }

  private getParameterValue(param: string) {
    if(param === 'tenantId' && sessionStorage.getItem('deviceModuleTenantId'))
      param = 'deviceModuleTenantId';
    return sessionStorage.getItem(param) ? sessionStorage.getItem(param) : null;
  }

  private setHeader(request: any) {
    const tenantId = JSON.parse(this.getParameterValue('tenantId'));
    const userId = this.getParameterValue('userId');
    const blobHeader = request.url.includes(environment?.azureBlobBaseUrl) ? 'BlockBlob' : null;
    const header = {
      'x-access-token': `${this.getToken()}`,
      'tenantId': `${tenantId}`,
      'userId': `${userId}`,
      'x-ms-blob-type': `${blobHeader}`,
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'X-XSS-Protection': '1; mode=block'
    };
    Object.entries(header).forEach((item: any) => {
      if (item[1] === 'null' || item[1] === 'undefined')
        delete header?.[item[0]];
    });
    return header;
  }
}
